import { useState } from "react";
import { LanguageProvider, useLanguage } from "./LanguageContext";
import Login from "./Login";
import LanguagePicker from "./LanguagePicker";
import Navbar from "./Navbar";
import Countdown from "./Countdown";
import Hero from "./Hero";

import RSVP from "./RSVP";
import Gallery from "./Gallery";
import FAQ from "./FAQ";
import Hotels from "./Hotels";
import "./index.css";

function CreditPopup({ onClose }) {
  return (
    <div style={{
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(30, 58, 95, 0.85)",
      backdropFilter: "blur(8px)",
    }}>
      <div
        className="animate-fade-in-up"
        style={{
          background: "white",
          borderRadius: "20px",
          padding: "48px 40px",
          maxWidth: "400px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        }}
      >
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ margin: "0 auto 16px" }}>
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="var(--blue-500)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: "1.5rem",
          color: "var(--blue-800)",
          marginBottom: "12px",
        }}>
          Website by
        </h2>
        <p style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: "1.3rem",
          color: "var(--blue-600)",
          fontStyle: "italic",
          marginBottom: "24px",
        }}>
          Elijah Qui&ntilde;ones
        </p>
        <button
          onClick={onClose}
          className="btn-wedding"
          style={{ padding: "12px 36px" }}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

function AppContent() {
  const [authenticated, setAuthenticated] = useState(
    () => sessionStorage.getItem("wedding-auth") === "true"
  );
  const [showCredit, setShowCredit] = useState(false);
  const { lang, t } = useLanguage();

  if (!authenticated) {
    return <Login onLogin={() => setAuthenticated(true)} />;
  }

  // Show language picker if no language selected yet
  if (!lang) {
    return <LanguagePicker onComplete={() => setShowCredit(true)} />;
  }

  // Show credit popup after language is picked
  if (showCredit) {
    return <CreditPopup onClose={() => setShowCredit(false)} />;
  }

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh" }}>
      <Navbar />
      <Hero />
      <Countdown targetDate="2026-07-02T00:00:00" />
      <Gallery />
      <RSVP />
      <FAQ />
      <Hotels />

      {/* Footer */}
      <footer style={{
        textAlign: "center",
        padding: "40px 20px",
        background: "var(--blue-900)",
        color: "rgba(255,255,255,0.6)",
      }}>
        <p style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: "1.5rem",
          color: "white",
          marginBottom: "8px",
        }}>
          Elijah & Diana
        </p>
        <p style={{ fontSize: "0.9rem", marginBottom: "4px" }}>
          {t.footerDate}
        </p>
        <p style={{ fontSize: "0.8rem", marginTop: "16px" }}>
          {t.footerMade}
        </p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
